import { render, staticRenderFns } from "./defects_config.vue?vue&type=template&id=305731d8&scoped=true"
import script from "./defects_config.vue?vue&type=script&lang=js"
export * from "./defects_config.vue?vue&type=script&lang=js"
import style0 from "./defects_config.vue?vue&type=style&index=0&id=305731d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305731d8",
  null
  
)

export default component.exports